import { useUser } from "@utils/store/user/useUser";
import { isPracticeMode } from "@utils/practice/practiceMode";
import { shouldSetupPhone } from "./phoneSetupPolicy";

/**
 * 結帳頁是否要先補登手機號碼（兩條結帳流程共用：/kiosk/confirm 與 /gasShop/cart）。
 *
 * 判斷本身是純函式（phoneSetupPolicy.shouldSetupPhone），這裡只負責把 store 的值餵進去：
 *  - userData.phone      ← GET /customer/home 的 customer.main_phone
 *  - accountPhoneLoaded  ← 上面那支真的回來過（分辨「還沒載入」與「帳號沒有手機」）
 *
 * 補登成功後由 CheckoutPhoneSetup 把號碼寫回 userData.phone，這個 hook 自然翻成 false，
 * 閘門就解開了——不需要另外一個「已完成」旗標。
 */
export const useNeedPhoneSetup = (): boolean => {
  const userData = useUser((s) => s.userData);
  const accountPhoneLoaded = useUser((s) => s.accountPhoneLoaded);
  return shouldSetupPhone({
    accountPhone: userData?.phone,
    accountLoaded: accountPhoneLoaded || !!userData?.phone,
    practiceMode: isPracticeMode(),
  });
};
